import _slicedToArray from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _taggedTemplateLiteral from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
var _excluded = ["onWishList", "iconOnly", "addReward", "removeReward", "t"],
    _excluded2 = ["id"];

var _templateObject;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { makeReference } from '@apollo/client';
import { AppAlertsContext } from '@infl-ts/ui-app-alerts';
import { Star, StarOutline } from '@mui/icons-material';
import { Button, IconButton, styled, useTheme } from '@mui/material';
import * as E from 'fp-ts/Either';
import { constFalse, constTrue, flow, pipe } from 'fp-ts/function';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { UnavailableInLens } from '../unavailable-in-lens';
import * as alerts from './alerts';
import { useAddRewardToWishlist, useRemoveRewardFromWishlist } from './mutations';
import { jsx as _jsx } from "react/jsx-runtime";
var SimpleIconButton = styled(IconButton)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  padding: 0;\n  height: ", ";\n\n  &:hover {\n    background-color: transparent;\n  }\n"])), function (p) {
  return p.theme.spacing(3.5);
});

var PureWishlistButton = function PureWishlistButton(_ref) {
  var onWishList = _ref.onWishList,
      _ref$iconOnly = _ref.iconOnly,
      iconOnly = _ref$iconOnly === void 0 ? false : _ref$iconOnly,
      addReward = _ref.addReward,
      removeReward = _ref.removeReward,
      t = _ref.t,
      rest = _objectWithoutProperties(_ref, _excluded);

  var theme = useTheme();

  var WishStar = function WishStar(_ref2) {
    var filled = _ref2.filled,
        _ref2$iconOnly = _ref2.iconOnly,
        iconOnly = _ref2$iconOnly === void 0 ? false : _ref2$iconOnly;
    return filled ? /*#__PURE__*/_jsx(Star, {
      sx: {
        mb: 0.25
      },
      htmlColor: iconOnly ? theme.palette.other.activeRating : 'inherit'
    }) : /*#__PURE__*/_jsx(StarOutline, {
      htmlColor: iconOnly ? theme.palette.secondary.dark : 'inherit',
      sx: {
        mb: 0.25
      }
    });
  };

  return /*#__PURE__*/_jsx(UnavailableInLens, {
    tooltip: true,
    "data-element": "UnavailableInLens",
    "data-component": "PureWishlistButton",
    "data-source-file": "wishlist-button.tsx",
    children: iconOnly ? /*#__PURE__*/_jsx(SimpleIconButton, _objectSpread(_objectSpread({}, rest), {}, {
      disabled: rest.disabled,
      title: onWishList ? t('Remove from wishlist') : t('Save to wishlist'),
      onClick: onWishList ? removeReward : addReward,
      children: /*#__PURE__*/_jsx(WishStar, {
        filled: onWishList,
        iconOnly: iconOnly
      })
    })) : /*#__PURE__*/_jsx(Button, _objectSpread(_objectSpread({}, rest), {}, {
      disabled: rest.disabled,
      onClick: onWishList ? removeReward : addReward,
      variant: "outlined",
      startIcon: /*#__PURE__*/_jsx(WishStar, {
        filled: onWishList
      }),
      children: onWishList ? t('Remove from wishlist') : t('Add to wishlist')
    }))
  });
};

var useAddMutations = function useAddMutations(_ref3) {
  var id = _ref3.id,
      props = _objectWithoutProperties(_ref3, _excluded2);

  var _useContext = useContext(AppAlertsContext),
      showAlert = _useContext.showAlert;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var updateWishlist = function updateWishlist(cache, action) {
    if (action.__typename === 'RewardWishlistErrors') return;
    cache.modify({
      id: cache.identify(makeReference("Reward:".concat(id))),
      fields: {
        onWishList: action.reward.onWishList ? constTrue : constFalse
      }
    });
    cache.evict({
      id: cache.identify(makeReference('ROOT_QUERY')),
      fieldName: 'rewards'
    });
    cache.gc();
  };

  var _useAddRewardToWishli = useAddRewardToWishlist({
    onCompleted: E.match(function () {
      return showAlert(alerts.addFailure(handleAddToWishlist, t));
    }, function (_ref4) {
      var addRewardToWishlist = _ref4.addRewardToWishlist;
      return pipe(addRewardToWishlist.__typename === 'RewardWishlistResult' ? alerts.addSuccess(handleRemoveFromWishlist, t) : alerts.addFailure(handleAddToWishlist, t), showAlert);
    }),
    update: function update(cache, data) {
      return pipe(data, E.match(function (e) {
        return console.error(e);
      }, function (_ref5) {
        var addRewardToWishlist = _ref5.addRewardToWishlist;
        return updateWishlist(cache, addRewardToWishlist);
      }));
    }
  }),
      _useAddRewardToWishli2 = _slicedToArray(_useAddRewardToWishli, 1),
      addReward = _useAddRewardToWishli2[0];

  var _useRemoveRewardFromW = useRemoveRewardFromWishlist({
    onCompleted: E.match(function () {
      return showAlert(alerts.removeFailure(handleRemoveFromWishlist, t));
    }, function (_ref6) {
      var removeRewardFromWishlist = _ref6.removeRewardFromWishlist;
      return pipe(removeRewardFromWishlist.__typename === 'RewardWishlistResult' ? alerts.removeSuccess(handleAddToWishlist, t) : alerts.removeFailure(handleRemoveFromWishlist, t), showAlert);
    }),
    update: function update(cache, data) {
      return pipe(data, E.match(function (e) {
        return console.error(e);
      }, function (_ref7) {
        var removeRewardFromWishlist = _ref7.removeRewardFromWishlist;
        return updateWishlist(cache, removeRewardFromWishlist);
      }));
    }
  }),
      _useRemoveRewardFromW2 = _slicedToArray(_useRemoveRewardFromW, 1),
      removeReward = _useRemoveRewardFromW2[0];

  var handleAddToWishlist = function handleAddToWishlist() {
    return addReward({
      variables: {
        id: id
      }
    });
  };

  var handleRemoveFromWishlist = function handleRemoveFromWishlist() {
    return removeReward({
      variables: {
        id: id
      }
    });
  };

  return _objectSpread({
    addReward: handleAddToWishlist,
    removeReward: handleRemoveFromWishlist,
    t: t
  }, props);
};

export default Object.assign(flow(useAddMutations, PureWishlistButton), {
  displayName: 'WishlistButton'
});